import { useState } from "react";
import { Link } from "react-router-dom";
import { requestCustomerPasswordReset } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    try {
      const result = await requestCustomerPasswordReset(email);
      setMessage(result.message);
    } catch {
      setMessage("If that email has a MySiteCare account, reset instructions have been sent.");
    } finally { setBusy(false); }
  };

  return <div className="min-h-[70vh] bg-slate-50 px-4 py-16"><div className="mx-auto max-w-md rounded-2xl border bg-white p-8 shadow-sm">
    <h1 className="text-2xl font-bold">Reset your password</h1>
    <p className="mt-2 text-sm text-slate-600">Enter your account email. For privacy, the response is the same whether or not an account exists.</p>
    {message ? <div className="mt-6 rounded-xl bg-emerald-50 p-4 text-sm text-emerald-800" role="status">{message}</div> : <form className="mt-6 space-y-4" onSubmit={submit}>
      <label className="block text-sm font-medium">Email<input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 w-full rounded-xl border px-4 py-3" data-testid="forgot-password-email-input" /></label>
      <button disabled={busy} className="w-full rounded-xl bg-slate-900 px-4 py-3 font-semibold text-white disabled:opacity-50" data-testid="forgot-password-submit-button">{busy ? "Sending…" : "Send reset link"}</button>
    </form>}
    <Link to="/account/login" className="mt-6 inline-block text-sm font-semibold text-emerald-600">Back to sign in</Link>
  </div></div>;
}
